import { RoleInput } from '@/types/role';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function role(axios: any) {
  async function getRoles(filter: any) {
    try {
      const response = await axios.get(`/api/roles?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/roles] getRoles Error', e);
    }
    return null;
  }

  async function getRole(id: number) {
    try {
      const response = await axios.get(`/api/roles/${id}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/roles] getMaterials Error', e);
    }
    return 0;
  }

  async function createRole(payload: RoleInput) {
    const response = await axios.post('/api/roles', (payload));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/roles] createRole Error', e);
    }
    return null;
  }

  async function updateRole(id: number, payload: RoleInput) {
    const response = await axios.put(`/api/roles/${id}`, camelObjectToSnakeObject(payload, ['permissions']));
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/roles] updateRole Error', e);
    }
    return null;
  }

  async function deleteRole(id: number) {
    const response = await axios.delete(`/api/roles/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/roles] deleteRole Error', e);
    }
    return null;
  }

  async function getPermissions() {
    const response = await axios.get('/api/permissions');
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/roles] getPermissions Error', e);
    }
    return null;
  }

  return {
    getRoles,
    getRole,
    createRole,
    updateRole,
    deleteRole,
    getPermissions,
  };
}
